import { Avatar, Button, Divider, Modal } from 'antd'
import { useState } from 'react';
import styles from './MobileSidebar.module.scss';
import { CloseOutlined, MenuOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../redux/store';
import { useNavigate } from 'react-router-dom';
import { AdminType, ClientType, ProfessionalType } from '../../../../types';
import Cookies from 'js-cookie';
import { authActions } from '../../../../redux/slices';
import { ModalContentWrapper } from './style';

const MobileSidebar = () => {
  const navigate = useNavigate();
  const { user } = useSelector((state: RootState) => state.auth);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const auth = authActions;

  const [showSignoutModal, setShowSignoutModal] = useState<boolean>(false);

  const isClient = (user: ProfessionalType | ClientType | AdminType | null): user is ClientType => {
    return !!user && 'professionalCode' in user;
  };

  const toggleMenu = () => {
    setIsOpen((prev) => (!prev));
  };

  const onSignOut = () => {
    setShowSignoutModal(false);

    Cookies.remove('user');
    Cookies.remove('auth_token');

    auth.removeAuth();
    navigate('/');
  };

  const handleBack = () => {
    setShowSignoutModal(false);
  };

  const onVisitLink = <T,>(link: string, payload?: T) => {
    navigate(link, payload && { state: payload });
  };

  return (
    <div className={styles.container}>
      <Button
        type="text"
        onClick={toggleMenu}
        className={styles.hamburgerMenuBtn}
        icon={
          <MenuOutlined className={styles.hamburgerMenuIcon} />
        }
      >
      </Button>
      <div className={`${styles.sidebar} ${isOpen ? styles.open : ''}`}>
        <Button
          type="text"
          onClick={toggleMenu}
          className={styles.closeBtn}
          icon={
            <CloseOutlined className={styles.closeMenuBtn} />
          }
        >
        </Button>
        <div className={styles.sidebarContent}>
          <div className={styles.professionalDetailsContainer}>
            <Avatar
              size={{ xs: 62, sm: 62, md: 62, lg: 0, xl: 0, xxl: 0 }}
            />
            <h2>Hello {user?.firstName} {user?.familyName}</h2>
          </div>
          <div className={styles.dividerContainer}>
            <Divider className={styles.divider} />
            {/* <p>Dashboard</p> */}
          </div>
          <ul>
            <li onClick={() => onVisitLink(`/c/${isClient(user) ? user?.professionalCode : 'dashboard'}`, null)}>Dashboard</li>
            <li onClick={() => onVisitLink(`/c/${isClient(user) ? user?.professionalCode : 'dashboard'}`, null)}>My Info</li>
            <li onClick={() => onVisitLink(`/c/${isClient(user) ? user?.professionalCode : 'dashboard'}`, null)}>Inmail</li>
            <li onClick={() => setShowSignoutModal(true)}>Signout</li>
          </ul>
          {/* <div className={styles.dividerContainer}>
            <Divider className={styles.divider} />
            <p>Mijn Info</p>
          </div>
          <ul>
            <li>My Integrated Health</li>
          </ul> */}
        </div>
      </div>
      <Modal
        title={`Signout`}
        open={showSignoutModal}
        onOk={onSignOut}
        onCancel={handleBack}
        // footer={null}
        width={350}
      >
        <ModalContentWrapper>
          <span>Are you sure you want to sign out?</span>
        </ModalContentWrapper>
      </Modal>
    </div>
  )
}

export default MobileSidebar